/**
 * Created by sivanh on 09/01/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/api-keys/apiKeyIpRangesListView.tmpl");
    var ApiKeyIpRangeItemView = require("manager-views/data-sources/api-keys/ApiKeyIpRangeItemView");

    var ApiKeyIpRangesListView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {


        ApiKeyIpRangesListView = Marionette.CompositeView.extend({
            itemViewContainer: '.ip-restriction-collection-container',
            template: template,
            itemView: ApiKeyIpRangeItemView,

            ui: {
                ipRangeContainer: ".ip-restriction-ip-ranges-container",
                readOnlyWarningMessageContainer: ".read-only-mode-warning-message-container"
            },

            events: {
                "click .ip-ranges-add-more": "_addNewIpRange"
            },

            initialize: function (options) {
                this.channel = options.channel;
                this.ipRangesReadOnlyMode = options.ipRangesReadOnlyMode;
                this.itemViewOptions = {channel: options.channel, ipRangesReadOnlyMode: this.ipRangesReadOnlyMode};
                this.container = options.container;
            },

            onRender: function () {
                if (this.container) {
                    this.container.append(this.$el);
                }
                this._bindEvents();
                this._manageSingleItemState();
                this._setIpRangeReadOnlyMode();
            },

            _setIpRangeReadOnlyMode: function() {
                if(this.ipRangesReadOnlyMode) {
                    this.ui.readOnlyWarningMessageContainer.removeClass("hide");
                    this.ui.ipRangeContainer.addClass("read-only-mode"); //change ip-input to disable design and hide +add ip range and x
                }
            },

            _bindEvents: function () {
                this.listenTo(this.collection, "add", this._onIpRangeChange);
                this.listenTo(this.collection, "remove", this._onIpRangeChange);
                this.listenTo(this, "itemview:close:clicked", this._onIpRangeClose);
            },

            _addNewIpRange: function () {
                this.channel.trigger("apiKey:change:ipRangesCollection:add");
            },

            _onIpRangeChange: function () {
                this._manageSingleItemState();
                this.channel.trigger("apiKey:change:ipRangesCollection");
            },
            _onIpRangeClose: function(childView, model){
                if (this.collection.size() > 1) {
                    LEManager.logger.debug("IP range item removed from IP Restriction list", "ApiKeyIpRangesListView:bindEvents");
                    this.channel.trigger("apiKey:change:ipRangesCollection:close", model);
                }
            },

            //sets the class "single-item" when 'x' should not be displayed, and removes it otherwise
            _manageSingleItemState: function () {
                var singleItem = this.collection.size() === 1;
                this.ui.ipRangeContainer.toggleClass("single-item", singleItem);
            }

        });
    });

    return ApiKeyIpRangesListView;
});
